import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-8"},[_c(VBtn,{staticClass:"rounded-pill memberid-white--text font-weight-bold subtitle-1",attrs:{"id":"custom-disabled-next","height":"52","width":"100%","color":"memberid-primary","disabled":_vm.isdisabled},on:{"click":function($event){return _vm.goToNextPage()}}},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }